export default __webpack_public_path__ + "static/media/Physicians Mutual.f8e90790.svg";